import(/* webpackMode: "eager" */ "/home/runner/work/vhire/vhire/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.9.0_@playwright+test@1.60.0_react-_d42ba7598167114c09618396f6df1214/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/vhire/vhire/node_modules/.pnpm/next@14.2.35_@babel+core@7.29.0_@opentelemetry+api@1.9.0_@playwright+test@1.60.0_react-_d42ba7598167114c09618396f6df1214/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/vhire/vhire/v4-frontend/src/components/marketing/hero/hero.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/vhire/vhire/v4-frontend/src/components/marketing/hero/nav.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/vhire/vhire/v4-frontend/src/components/marketing/sections/command-center.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/vhire/vhire/v4-frontend/src/components/marketing/sections/confidence.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/vhire/vhire/v4-frontend/src/components/marketing/sections/faq.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/vhire/vhire/v4-frontend/src/components/marketing/sections/footer.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/vhire/vhire/v4-frontend/src/components/marketing/sections/fragmentation.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/vhire/vhire/v4-frontend/src/components/marketing/sections/infrastructure.tsx");
